/** Плитка картинки героини: превью, цена и время задачи, статус; клик открывает крупно. */
import clsx from "clsx";

import { RetryImg } from "@/components/trends/PinGrid";
import { mediaUrl } from "@/lib/media";
import type { ImageStatus, PersonaImage } from "@/lib/persona";
import { usd } from "@/lib/project";

const BADGE: Record<ImageStatus, { text: string; cls: string } | null> = {
  new: null,
  rejected: { text: "отклонена", cls: "bg-bg-hover text-fg-faint" },
  approved: { text: "одобрена", cls: "bg-ok-bg text-ok" },
  canon: { text: "канон", cls: "bg-accent-dim text-accent-text" },
};

export function ImageCard({
  image,
  seconds,
  open,
  onOpen,
}: {
  image: PersonaImage;
  seconds: number | null;
  open: boolean;
  onOpen: (id: number) => void;
}) {
  const badge = BADGE[image.status];
  return (
    <button
      type="button"
      onClick={() => onOpen(image.id)}
      className={clsx(
        "group grid min-w-0 gap-1 rounded-[var(--radius-ui)] text-left",
        open && "outline-2 outline-offset-2 outline-accent",
      )}
    >
      <span
        className={clsx(
          "relative block overflow-hidden rounded-[var(--radius-ui)] border border-border bg-bg",
          image.kind === "sheet" ? "aspect-[3/2]" : "aspect-[3/4]",
        )}
      >
        <RetryImg
          src={mediaUrl(image.asset_path)}
          alt=""
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
        />
        {badge ? (
          <span className={clsx("absolute top-1.5 left-1.5 rounded-[4px] px-1.5 py-0.5 text-[11px] font-medium", badge.cls)}>
            {badge.text}
          </span>
        ) : null}
      </span>
      <span className="text-[11.5px] text-fg-faint tnum">
        {usd(image.cost)}
        {seconds !== null ? ` · ${Math.round(seconds)} с` : ""}
      </span>
    </button>
  );
}
